import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "webins-reservation-summary" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "amount-top text-theme-color" }, "Preventivo Assicurazione", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", {
  width: "90%",
  size: "1",
  color: "#c3c3c3",
  noshade: ""
}, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "summary-step-detail" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Polizza ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "summary-step-detail" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Date viaggio")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "summary-step-detail" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { style: {"padding-bottom":"10px"} }
const _hoisted_14 = { class: "summary-step-detail" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Viaggiatori")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "webins-amount-bottom"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", {
  width: "90%",
  size: "1",
  color: "#c3c3c3",
  noshade: ""
}, null, -1)
const _hoisted_19 = { style: {"margin-bottom":"10px"} }
const _hoisted_20 = { class: "d-flex justify-content-between align-items-center text-theme-color" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("span", null, " Totale: ")
], -1)
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("small", null, " di cui imposte: ", -1)
const _hoisted_24 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("small", null, " Sconto applicato: ", -1)

import { computed, defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import dayjs from "dayjs";
import { useReservation, useNavigation, useWidget, usePolizze } from "@/composables";
import { ParametriPreventivatoreFasceEta } from "@/models/ParametriPreventivatore";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { loading, parametriPreventivatore, totali, rigaCarrelloDati, numberToCurrency } = usePolizze();
const { destinazioniPreventivatore, elencoEta } = useWidget();

const { t } = useI18n();
const { modeCar } = useWidget();
const { currentStep } = useNavigation();


const partecipantiPerFascia = computed(() => {
    if( !parametriPreventivatore.value.fasceEta || !parametriPreventivatore.value.fasceEta.length )
        return [];

    var p = []
    for( var i = 0; i < parametriPreventivatore.value.fasceEta.length; i++){
        if(parametriPreventivatore.value.fasceEta[i].numeroPartecipanti )
            p.push(parametriPreventivatore.value.fasceEta[i]);
    }
    return p;
});

const inizioViaggio = computed(() => {
    if (parametriPreventivatore.value.inizioViaggio != null) {
        return dayjs(parametriPreventivatore.value.inizioViaggio).format(t("common.dateUIFormat") || "DD/MM/YYYY");
    }
    return "?";
});

const fineViaggio = computed(() => {
    if (parametriPreventivatore.value.fineViaggio != null) {
        return dayjs(parametriPreventivatore.value.fineViaggio).format(t("common.dateUIFormat") || "DD/MM/YYYY");
    }
    return "?";
});

const destinazioneNome = computed(() => {
    if (parametriPreventivatore.value.destinazioneStato != null) {
        var d = destinazioniPreventivatore.value.find((a) => a.value === parametriPreventivatore.value.destinazioneStato);
        return d && d.text ? d.text : "-";
    }
    return "-";
});



const eta = computed(() => {
    if (parametriPreventivatore.value.eta != null) {
        var d = elencoEta.value.find((a) => a.value === parametriPreventivatore.value.eta);
        return d && d.text ? d.text : "-";
    }
    return "-";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_unref(currentStep) >= 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("strong", null, [
              _createElementVNode("p", null, _toDisplayString(_unref(rigaCarrelloDati).datiProdotto.pacchetto), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("strong", null, [
          _createElementVNode("p", null, _toDisplayString(_unref(inizioViaggio)) + " - " + _toDisplayString(_unref(fineViaggio)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_11, [
        _createTextVNode(_toDisplayString(_unref(t)("common.destination")), 1),
        _hoisted_12,
        _createElementVNode("strong", null, [
          _createElementVNode("p", null, _toDisplayString(_unref(destinazioneNome)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _hoisted_16,
        _createElementVNode("strong", null, [
          _createElementVNode("p", null, _toDisplayString(_unref(parametriPreventivatore).numeroPartecipanti || "-"), 1)
        ])
      ])
    ]),
    (_unref(currentStep) >= 2 && _unref(totali))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("span", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("strong", null, [
                _createElementVNode("span", null, _toDisplayString(_unref(numberToCurrency)(String(_unref(totali).totaleViaggio))), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("small", null, _toDisplayString(_unref(numberToCurrency)( String(_unref(totali).totaleViaggioImposte))), 1)
            ]),
            (_unref(totali).scontoCoupon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("small", null, _toDisplayString(_unref(numberToCurrency)( String(_unref(totali).scontoCoupon))), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})